import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {
  GenerateOtpRequest,
  OtpResponse,
  ResendOtpRequest, ResetPasswordRequest,
  VerifyOtpRequest,
  VerifyOtpResponse
} from '../../models/otp.models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OtpApiService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/api/v1/otp`;

  generateOtp(request: GenerateOtpRequest): Observable<OtpResponse> {
    return this.http.post<OtpResponse>(`${this.apiUrl}/generate`, request);
  }

  verifyOtp(request: VerifyOtpRequest): Observable<VerifyOtpResponse> {
    return this.http.post<VerifyOtpResponse>(`${this.apiUrl}/verify`, request);
  }

  resendOtp(request: ResendOtpRequest): Observable<OtpResponse> {
    return this.http.post<OtpResponse>(`${this.apiUrl}/resend`, request);
  }

  resetPassword(request: ResetPasswordRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/reset-password`, request);
  }

}
